@import (reference) '../../../../../../../../constants/spacing.module.less';

.selected-card {
  cursor: pointer;
  border-color: var(--mantine-color-blue-5);
  border-width: 2px;
  background-color: var(--mantine-color-blue-0);
}

.selectable-card {
  cursor: pointer;
}

.package-dropdown {
  > div {
    width: 100%;
  }
}
